module.exports = __webpack_public_path__ + "img/D201707_2.30e19639.jpg";